import React, {useState} from "react";
import {Icon, Inner, Main, Message, Padding, Title} from "./style";
import {Button, Input} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import {userDisableMfa} from "../../../store/auth/mfa/actions";
import {logoutUser} from "../../../store/auth/login/actions";

const LegacySubdomainRedirect = ({ history, migrated }) => {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const org = useSelector((state) => state.Variables.org);
    const env = useSelector((state) => state.Variables.env);
    const dispatch = useDispatch();
    const [password, setPassword] = useState("");
    const full = window.location.host;
    const parts = full.split(".");
    const sub = org || parts[0];

    // Hardcoded redirect logic
    let final = "";
    if (full === "tdamp.bitgowealthmanagement.com") {
        final = "https://wm.bitgo.com/";
    } else if (full === "tdamp.heightzero.io") {
        final = "https://wm.bitgo.com/heightzero";
    } else {
        final = `https://${env.VARIANT === "TOKEN_MGMT" ? "tkm" : "wm"}.bitgo.com/${sub}`;
    }

    return (
        <Main>
            <Padding>
                <Inner>
                    <Icon>
                        <i className={migrated ? "bx bx-check-circle text-primary" : "bx bx-info-circle text-primary"} />
                    </Icon>
                    <Title>{migrated ? "Migration Complete" : "Security Update Required"}</Title>
                    {migrated ? (
                        <Message>
                            {`You have successfully migrated your BitGo ${env.VARIANT === "TOKEN_MGMT" ? "Token Management" : "Wealth Management"} portal to bitgo.com. As part of this transition, we've enhanced our security protocols to better protect your account.

To continue using our services, please access your portal directly at ${final}. Your previous authentication method has been retired — if you haven’t already, you’ll need to complete the two-factor authentication (2FA) setup on the new site.

Click Go to BitGo.com to securely log in and manage your account.`}
                        </Message>
                    ) : (
                        <Message>
                            {`You are currently accessing your BitGo ${env.VARIANT === "TOKEN_MGMT" ? "Token Management" : "Wealth Management"} portal at ${full}. As part of our migration to BitGo.com, we've updated our security protocols and have moved all services to the BitGo.com domain.

To maintain the integrity of your account, your current two-factor authentication (2FA) will be retired. You are required to re-authenticate on the new portal to continue secure access.

Click Secure My Account to acknowledge this change. You'll be redirected to the new BitGo portal to set up 2FA and restore access.`}
                        </Message>
                    )}
                    <Message>
                        {!migrated && (
                            <Input
                                value={password}
                                type="password"
                                name="password"
                                className="mb-2"
                                placeholder="Enter account password..."
                                onChange={(event) => setPassword(event.target.value)}
                            />
                        )}
                        <Button
                            disabled={!password && !migrated}
                            color="primary"
                            block
                            onClick={() => {
                                const runMigrate = () => {
                                    const newTab = window.open(`${final}?loading=1`);
                                    if (newTab) {
                                        const messageHandler = (event) => {
                                            if (event.origin === env.ROOT_HOST && event.data === "READY") {
                                                newTab.postMessage({ user: { ...authUser, mfa: null }}, env.ROOT_HOST);
                                                window.removeEventListener("message", messageHandler);
                                                dispatch(logoutUser(history));
                                            }
                                        };
                                        window.addEventListener("message", messageHandler);
                                    }
                                };

                                if (!migrated) {
                                    dispatch(userDisableMfa({ password }, history, () => runMigrate()));
                                } else {
                                    runMigrate();
                                }
                            }}
                        >
                            {migrated ? "Go to BitGo.com" : "Secure My Account"}
                        </Button>
                        <Button color="danger" block onClick={() => dispatch(logoutUser(history))}>
                            Logout
                        </Button>
                    </Message>
                </Inner>
            </Padding>
        </Main>
    );
};

export default LegacySubdomainRedirect;
